import React from 'react';
import MeetingFilteredList from './MeetingFilteredList';

const FutureMeetings = () => {
  return (
    <MeetingFilteredList 
      title="Gelecek Görüşmeler"
      filterType="future"
    />
  );
};

export default FutureMeetings;
